import { ISetPriorityParams } from '../types/actionParams';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export class SetExtractTasksPriorityRequest extends Request<ISetPriorityParams, IResult> {
  constructor(ids: string[], priority: number) {
    super('setExtractTasksPriority', {
      ids: ids,
      priority: priority
    });
  }
}
